import { AdminService, AdminUsersResponseDto } from 'app/API';
import type { TCall } from 'app/queries/types/TCall';

const EXPORT_ORDER = { orderBy: 'createdAt', orderType: 'desc' } as const;

export const fetchAllUsersForExport = async (call: TCall, search: string): Promise<AdminUsersResponseDto> => {
  const baseExportParams = { pageNo: '1', search, ...EXPORT_ORDER };
  const countResponse = await call(() => AdminService.getAllUsers({ ...baseExportParams, pageSize: '1' }));

  if (countResponse.count === 0) {
    return { count: 0, data: [] };
  }

  return call(() => AdminService.getAllUsers({ ...baseExportParams, pageSize: countResponse.count.toString() }));
};
